import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const SideNav = (props) => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const translations = useSelector((state) => state.translation.translations);
  const { activeKey, setActiveKey, faqs } = props;

  const titleFormatter = (key) => {
    let value;
    translations.forEach((translation) => {
      if (
        key === translation.translationKey &&
        translation.language.toLowerCase() === currentLanguage
      ) {
        value = translation.translationValue;
        return;
      }
    });

    return value;
  };

  return (
    <div className="faq-side-bar-container" mt={12}>
      <ul className="faq-side-bar-list" mt={12}>
        {faqs.map((item, index) => (
          <li
            className={`faq-side-bar-item ${
              activeKey === item.translationKey ? "active" : ""
            }`}
            onClick={() => setActiveKey(item.translationKey)}
            key={item.translationKey}
            color="black"
          >
            {titleFormatter(item.translationKey)}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SideNav;
